import { render, staticRenderFns } from "./detail_template.vue?vue&type=template&id=09296bac&scoped=true&"
import script from "./detail_template.vue?vue&type=script&lang=js&"
export * from "./detail_template.vue?vue&type=script&lang=js&"
import style0 from "./detail_template.vue?vue&type=style&index=0&id=09296bac&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09296bac",
  null
  
)

export default component.exports